import { createSelector } from 'reselect';
import { selectors as userSelectors } from '../users';
import { selectors as skillSelectors } from '../skills';
import { selectors as membershipSelectors } from '../memberships';
import { selectors as combinedSchedulesSelectors } from '../combined-schedules';
import { selectors as rankSelectors } from '../ranks';
import { uniqBy, sortBy } from 'lodash';

export const augmentUser = createSelector(
  userSelectors.byId,
  skillSelectors.byId,
  membershipSelectors.byId,
  rankSelectors.byId,
  combinedSchedulesSelectors.currentTime.membership,
  (usersById, skillsById, membershipsById, ranksById, membershipAvailability) => userId => {
    let user = usersById[userId];
    let userSkills = [];

    if (!user) return null;

    if (!user.memberships) return user;

    const memberships = (user.memberships || []).map(membership => {
      const fullMembership = membershipsById[membership.id] || membership;

      const membershipSkills = (fullMembership.skills || []).map(skillId => skillsById[skillId]);

      userSkills = [...userSkills, ...membershipSkills];

      return {
        ...fullMembership,
        skills: membershipSkills || fullMembership.skills || [],
        override_rank: ranksById[membership.override_rank_id] || null,
        availability: membershipAvailability[membership.id] || null
      };
    });

    const rank = ranksById[user.rank_id] || null;

    userSkills = sortBy(uniqBy(userSkills, 'id'), 'order');

    return {
      ...user,
      skills: userSkills,
      memberships,
      rank
    };
  }
);
